var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',{staticClass:"bg-dark",attrs:{"items":_vm.crumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }